class CollectionDescription extends HTMLElement {
  MAX_LENGTH = 500;
  SHOW_MORE = true;
  constructor() {
    super();
    this.descriptionFull = this.innerHTML;

    if (this.getAttribute("show-more") === "false") {
      this.SHOW_MORE = false;
    }

    if (this.getAttribute("max-length")) {
      this.MAX_LENGTH = parseInt(this.getAttribute("max-length"));
    }

    if (this.innerText.length > this.MAX_LENGTH) {
      // truncate HTML while preserving tags and structure
      const readMoreLink = `... <a class="readmore" href="${this.showMoreHref}">Voir plus&gt;</a>`;
      this.descriptionClipped = this.truncateHTML(this.descriptionFull, this.MAX_LENGTH, readMoreLink);

      // replace original content with cropped desc
      this.innerHTML = this.descriptionClipped;

      // remove processing class
      this.classList.remove("processing");

      // move original description to bottom
      if (this.SHOW_MORE) {
        const bottomDescContainer = document.getElementById("full-description");
        if (bottomDescContainer) {
          bottomDescContainer.innerHTML = this.descriptionFull;
        }
      }
    }
  }

  truncateHTML(html, maxLength, readMoreLink) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    let charCount = 0;
    let result = document.createElement('div');
    let lastContainer = null;

    const processNode = (node, container) => {
      if (charCount >= maxLength) return false;

      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        const remainingChars = maxLength - charCount;

        if (text.length <= remainingChars) {
          container.appendChild(node.cloneNode(true));
          charCount += text.length;
          lastContainer = container;
          return true;
        } else {
          // Truncate at word boundary
          let truncated = text.substring(0, remainingChars);
          const lastSpace = truncated.lastIndexOf(' ');
          if (lastSpace > 0) {
            truncated = truncated.substring(0, lastSpace);
          }
          container.appendChild(document.createTextNode(truncated));
          lastContainer = container;
          charCount = maxLength;
          return false;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const clone = node.cloneNode(false);
        container.appendChild(clone);

        for (let child of node.childNodes) {
          if (!processNode(child, clone)) {
            return false;
          }
        }
        return true;
      }
      return true;
    };

    for (let child of tempDiv.childNodes) {
      if (!processNode(child, result)) {
        break;
      }
    }

    // Insert "read more" link inside the last container
    if (lastContainer && readMoreLink) {
      const linkFragment = document.createRange().createContextualFragment(readMoreLink);
      lastContainer.appendChild(linkFragment);
    }

    return result.innerHTML;
  }

  get showMoreHref(){
    return this.getAttribute('show-more-href') || '#full-description';
  }
}

customElements.define("collection-description", CollectionDescription);
